import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Location } from '@angular/common';
import { ToastService } from '@hutsix/ngxh6';
import { fadeInOut, fadeInOut2 } from '../../../../../../animations';
import { MacUserService } from '../../../../../../services/user/mac-user.service';
import { ApiResponse, DefaultFormComponent, FormServiceInterface, NavItem, ValueAccessorBase } from '@hutsix/ngxh6';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { User_default } from '../../../../../../api_types';
import { NgModelGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss'],
    animations: [fadeInOut, fadeInOut2],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UserFormComponent extends DefaultFormComponent implements AfterViewChecked, AfterViewInit {
    @ViewChildren('basicForm') basicForm: QueryList<NgModelGroup>;
    @ViewChildren('staffForm') staffForm: QueryList<ValueAccessorBase>;
    @ViewChildren('accountForm') accountForm: QueryList<ValueAccessorBase>;

    public navItems: NavItem[];

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('UserService') public userService: MacUserService,
        public location: Location,
        public cdRef: ChangeDetectorRef,
        public toastr: ToastService,
        public router: Router,
        public route: ActivatedRoute,
    ) {
        super(formService, userService, location, cdRef);
    }

    ngAfterViewInit(): void {
        this.navItems = [
            { id: 'basic', label: 'Basic info', destroyOnHide: false, watch: this.basicForm },
            { id: 'staff', label: 'Staff details', destroyOnHide: false, watch: this.staffForm },
            { id: 'account', label: 'Account', destroyOnHide: false, watch: this.accountForm },
        ];
    }

    ngAfterViewChecked(): void {
        if (this.form && this.formRef) {
            this.form.formRef = this.formRef;
        }
    }

    public submit(): void {
        if (this.beforeSubmit && !this.beforeSubmit(this.form.model)) return;
        this.form
            .submit(this.displayToast)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (res: ApiResponse<User_default>) => {
                    if (!this.form.editId) {
                        this.router.navigate(['../../users/' + res.data.id], { relativeTo: this.route });
                    } else {
                        this.submitted.emit(res);
                    }
                    this.cdRef.detectChanges();
                },
                err => {
                    this.cdRef.detectChanges();
                },
            );
    }

    onChange(v: any): void {
        // console.log(v);
    }
}
